import { render, staticRenderFns } from "./TherapyBlock.vue?vue&type=template&id=494b5796&lang=pug&"
import script from "./TherapyBlock.vue?vue&type=script&lang=js&"
export * from "./TherapyBlock.vue?vue&type=script&lang=js&"
import style0 from "./TherapyBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports